import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { CONFIG } from '../../config';


export const translateHttpLoaderProviders = provideTranslateHttpLoader({ prefix: CONFIG.i18nPath, suffix: '.json' });
